/* Progressive enhancement: native gallery/forms and every note remain server rendered. */
if (!customElements.get('one-product-stage')) {
  customElements.define('one-product-stage', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort(); this.abort = new AbortController();
      this.campaign = this.querySelector('[data-stage-campaign]');
      this.bottle = this.querySelector('[data-stage-bottle]');
      this.controls = this.querySelector('[data-stage-controls]');
      this.comparison = this.querySelector('[data-stage-compare]');
      this.galleryDisclosure = this.querySelector('[data-stage-gallery-disclosure]');
      if (!this.campaign || !this.bottle || !this.controls) return;
      const options = { signal: this.abort.signal };
      this.controls.hidden = false;
      const gallerySummary = this.galleryDisclosure?.querySelector('summary');
      if (gallerySummary) gallerySummary.hidden = true;
      this.controls.addEventListener('click', event => {
        const button = event.target.closest('[data-stage-view]');
        if (button) this.show(button.dataset.stageView);
      }, options);
      // Variant changes must expose the native, variant-selected image.
      this.closest('product-info')?.addEventListener('change', event => {
        if (event.target.closest('variant-selects')) this.show('bottle');
      }, options);
      this.show('campaign');
    }
    show(view) {
      if (!['campaign', 'bottle', 'compare'].includes(view) || (view === 'compare' && !this.comparison)) return;
      if (view !== 'bottle' && this.galleryDisclosure?.open) window.pauseAllMedia?.();
      if (view === 'compare' && !this.comparison.childElementCount) {
        const template = this.querySelector('[data-stage-compare-template]');
        if (!template) return;
        this.comparison.append(template.content.cloneNode(true));
      }
      this.campaign.hidden = view !== 'campaign';
      this.bottle.hidden = view !== 'bottle';
      if (this.galleryDisclosure) this.galleryDisclosure.open = view === 'bottle';
      if (this.comparison) this.comparison.hidden = view !== 'compare';
      this.controls.querySelectorAll('button').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.stageView === view)));
      if (view === 'bottle') window.dispatchEvent(new Event('resize'));
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
}
if (!customElements.get('one-image-compare')) {
  customElements.define('one-image-compare', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort(); this.abort = new AbortController();
      const range = this.querySelector('input[type="range"]');
      if (!range) return;
      const update = () => {
        const position = Math.max(0, Math.min(100, Number(range.value)));
        this.style.setProperty('--one-compare-position', `${position}%`);
        range.setAttribute('aria-valuetext', `Object ${position}%, detail ${100 - position}%`);
      };
      range.addEventListener('input', update, { signal: this.abort.signal });
      update();
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
}
if (!customElements.get('one-scent-explorer')) {
  customElements.define('one-scent-explorer', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort(); this.abort = new AbortController();
      this.stages = [...this.querySelectorAll('[data-note-stage]')];
      this.buttons = [...this.querySelectorAll('[data-explore-stage]')];
      this.range = this.querySelector('input[type="range"]');
      this.controls = this.querySelector('.one-explorer__controls');
      this.status = this.querySelector('[data-explorer-status]');
      this.readAll = this.querySelector('[data-explorer-all]');
      // Incomplete merchant data keeps the readable static composition.
      if (this.stages.length !== 3 || !this.range || !this.controls) return;
      this.controls.hidden = false;
      this.classList.add('is-enhanced');
      const options = { signal: this.abort.signal };
      this.range.addEventListener('input', () => this.select(Number(this.range.value), false), options);
      this.range.addEventListener('change', () => this.announce(), options);
      this.buttons.forEach((button, index) => button.addEventListener('click', () => this.select(index, true), options));
      if (this.readAll) {
        this.readAll.hidden = false;
        this.readAll.addEventListener('click', () => {
          const expanded = this.readAll.getAttribute('aria-expanded') !== 'true';
          this.readAll.setAttribute('aria-expanded', String(expanded));
          this.readAll.textContent = expanded ? 'Explore one stage at a time' : 'Read the full composition';
          this.classList.toggle('is-reading-all', expanded);
          if (expanded) this.stages.forEach(stage => { stage.hidden = false; });
          else this.select(this.index, false);
        }, options);
      }
      this.select(0, false);
    }
    select(index, announce) {
      this.index = Math.max(0, Math.min(2, index));
      this.dataset.activeStage = this.stages[this.index].dataset.noteStage;
      this.range.value = this.index;
      this.range.setAttribute('aria-valuetext', this.buttons[this.index].textContent.trim());
      this.buttons.forEach((button, i) => button.setAttribute('aria-pressed', String(i === this.index)));
      this.stages.forEach((stage, i) => { stage.hidden = !this.classList.contains('is-reading-all') && i !== this.index; });
      if (announce) this.announce();
    }
    announce() { this.status.textContent = this.stages[this.index].textContent.trim(); }
    disconnectedCallback() { this.abort?.abort(); }
  });
}
